import { render, staticRenderFns } from "./AppLayoutOnboarding.vue?vue&type=template&id=3831a492&scoped=true&"
import script from "./AppLayoutOnboarding.vue?vue&type=script&lang=js&"
export * from "./AppLayoutOnboarding.vue?vue&type=script&lang=js&"
import style0 from "./AppLayoutOnboarding.vue?vue&type=style&index=0&id=3831a492&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3831a492",
  null
  
)

export default component.exports